import React from 'react';
export function Bonos() {
  const bonos = [{
    num: '🎧 Bono #1',
    title: 'Meditaciones del Guerrero Íntimo',
    desc: '3 sesiones de audio guiadas para calmar la ansiedad, fortalecer el enfoque y reconectarte con ella. Basadas en mindfulness clínico aplicado a la salud sexual masculina.',
    valor: '$9,500'
  }, {
    num: '📋 Bono #2',
    title: 'El Plan de 30 Días',
    desc: 'Tu entrenamiento día a día. Ejercicios Kegel progresivos, práctica TCS, hábito mental del día y check de progreso semanal. Como el gimnasio, pero para tu desempeño.',
    valor: '$7,000'
  }, {
    num: '⚡ Bono #3',
    title: 'Guía de Emergencia: Esta Noche',
    desc: 'Las 5 técnicas que puedes aplicar HOY MISMO. El truco de respiración en 3 pasos, el script mental de 30 segundos y la posición estratégica que te da control inmediato.',
    valor: '$5,000'
  }];
  return <section className="py-[36px] px-5 bg-brand-black" data-id="element-16">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-17">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.4rem)] text-brand-white uppercase text-center mb-2 leading-[1.15]" data-id="element-18">
          Más Todo Esto —<br data-id="element-19" />
          <span className="text-brand-gold" data-id="element-20">Sin Costo Adicional</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-21"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-2.5" data-id="element-22">
          {bonos.map((bono, idx) => <div key={idx} className="bg-gradient-to-br from-[#111] to-[#140f00] border border-[#2a2200] border-t-[4px] border-t-brand-gold rounded-[10px] p-[24px_20px] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_35px_rgba(201,168,76,0.2)]" data-id="element-23">
              <span className="inline-block bg-brand-gold text-black font-montserrat text-[0.65rem] font-extrabold tracking-[2px] uppercase py-1 px-3 rounded-full mb-3" data-id="element-24">
                {bono.num}
              </span>
              <h3 className="font-montserrat font-extrabold text-[0.95rem] text-brand-white uppercase leading-[1.3] mb-2.5" data-id="element-25">
                {bono.title}
              </h3>
              <p className="text-[0.85rem] text-[#908b83] leading-[1.6] mb-3" data-id="element-26">
                {bono.desc}
              </p>
              <div className="font-montserrat text-[0.82rem] font-bold text-brand-gold" data-id="element-27">
                Valor: {bono.valor}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}